import * as types from '../../actions/actionTypes';

// Initial state
const defaultState = {
  campaigns: {},
  projects: {},
  statistic: {},
};

// Reducer
const voteReducer = (state = defaultState, action) => {
  const nextState = Object.assign({}, state);
  switch (action.type) {
    case types.FETCH_CAMPAIGNS_SUCCESS:
      return { ...state, campaigns: { ...state.campaigns, ...action.data } };
    case types.FETCH_PROJECT_SUCCESS:
      return { ...state, projects: { ...state.projects, ...action.data } };
    case types.FETCH_STATISTIC_SUCCESS:
      return { ...state, statistic: action.data };
    default:
      return nextState;
  }
};

export default voteReducer;
